import React from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PopupTitle from '../common/popup_title';
import {
  END_USER_RECIPE_COLLECTIONS_ROUTE,
  SMORG_STUDIO_SPACE_EDIT_ROUTE,
} from '../../services/routes';
import { userIsCreator } from '../../services/users';
import { DEFAULT_SPACE_ID } from '../../services/spaces';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetSharedProgrammesForEndUserQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const AccountActionsPopupMenuBottomnav = ({
  anchorEl,
  handleSignOut,
  handleClose,
}) => {
  const open = !!anchorEl;
  const navigate = useNavigate();

  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery(
    undefined,
    {
      skip: !userProfile || isSmorgStudio,
    },
  );

  const isCommunityUser = currentSpaceMembership?.spaceID === DEFAULT_SPACE_ID;

  const { data: sharedProgrammes } = useGetSharedProgrammesForEndUserQuery();

  const anyProgrammesAvailable =
    sharedProgrammes && sharedProgrammes.length > 0;

  const isProgramsAvailable = !isCommunityUser && anyProgrammesAvailable;

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: { minWidth: '220px' },
      }}>
      <PopupTitle
        titleText="Account actions"
        closeButtonEnabled
        onClickClose={handleClose}
      />
      {!isSmorgStudio && isProgramsAvailable && (
        <MenuItem
          onClick={() => {
            handleClose();
            navigate(END_USER_RECIPE_COLLECTIONS_ROUTE);
          }}>
          Collections
        </MenuItem>
      )}
      {!isSmorgStudio && (
        <MenuItem
          onClick={() => {
            handleClose();
            navigate('/products');
          }}>
          Shopping lists
        </MenuItem>
      )}
      {isSmorgStudio && (
        <MenuItem
          onClick={() => {
            handleClose();
            navigate('/programmes');
          }}>
          Programs
        </MenuItem>
      )}
      {isSmorgStudio && (
        <MenuItem
          onClick={() => {
            handleClose();
            navigate(SMORG_STUDIO_SPACE_EDIT_ROUTE);
          }}>
          Manage your App
        </MenuItem>
      )}
      <MenuItem
        onClick={() => {
          handleClose();
          navigate('/user');
        }}>
        My Profile
      </MenuItem>
      <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
    </Menu>
  );
};

AccountActionsPopupMenuBottomnav.propTypes = {
  anchorEl: PropTypes.element.isRequired,
  handleSignOut: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AccountActionsPopupMenuBottomnav;
